import { Connection } from "../../domain/entities/connection.entity";

export interface ConnectionApi {
    contractId: number;
    contractName: string;
    logoPath: string;
    lastReceptionCheckAt: string | null;
    lastSendAttemptAt: string | null;
}

export class ConnectionMapper {
    static toDomain(api: ConnectionApi): Connection {
        return {
            contractId: api.contractId,
            contractName: api.contractName,
            logoPath: api.logoPath ?? null,
            lastReceptionCheckAt: api.lastReceptionCheckAt ? new Date(api.lastReceptionCheckAt) : null,
            lastSendAttemptAt: api.lastSendAttemptAt ? new Date(api.lastSendAttemptAt) : null,

        };
    }
}